import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  reservationTitle,
  reservationSubContainerWithStep,
} from "../Part3/reservation-part-3.module.scss"
import {
  reservationPart5HeaderContainer,
  reservationPart5ChoiceWeekContainer,
  reservationPart5CreneauxContainer,
  reservationPart5WeekArrowRight,
  reservationPart5WeekArrowLeft,
  reservationPart5DatePickerContainer,
} from "./reservation-part-5.module.scss"
import {
  ReservationSubContainer,
  ReservationTitle,
  ReservationPart5WeekButton,
} from "../reservation-styled.js"
import { StepIndicator } from "../StepIndicator/step-indicator"
import { ReservationPart5DayColumn } from "./reservation-part-5-day-column.js"
import arrowBlack from "gatsby-theme-blank/src/images/full-arrow-black.svg"
import DatePicker, { registerLocale } from "react-datepicker"
import fr from "date-fns/locale/fr"
import "react-datepicker/dist/react-datepicker.css"

export const ReservationPart5 = ({
  creneauxDisponibles,
  changeWeekOffset,
  changeCreneau,
  creneauChoisi,
  loadingLock,
  step,
  stepRefs,
}) => {
  const today = new Date()
  const [datePickerDate, setDatePickerDate] = useState(new Date())
  const handleChange = (selectedDate) => {
    setDatePickerDate(selectedDate)
    const todayStart = startOfWeek(today)
    const selectedStart = startOfWeek(selectedDate)
    const diffInMs = selectedStart.getTime() - todayStart.getTime()
    changeWeekOffset(Math.floor(diffInMs / (7 * 24 * 60 * 60 * 1000)), true)
  }

  const startOfWeek = (date) => {
    const monday = new Date(date)
    const day = monday.getDay()
    const diff = (day === 0 ? -6 : 1) - day
    monday.setDate(monday.getDate() + diff)
    monday.setHours(0, 0, 0, 0)
    return monday
  }
  registerLocale("fr", fr)

  return (
    <ReservationSubContainer className={reservationSubContainerWithStep}>
      <StepIndicator step={step} refs={stepRefs} />
      <div className={reservationPart5HeaderContainer}>
        <ReservationTitle className={reservationTitle}>
          Choix d&apos;un ou plusieurs créneaux de réservation
        </ReservationTitle>
        <div className={reservationPart5ChoiceWeekContainer}>
          <ReservationPart5WeekButton onClick={() => changeWeekOffset(-1)}>
            <img
              className={reservationPart5WeekArrowLeft}
              src={arrowBlack}
              width={15}
              height={15}
            />{" "}
            Semaine précédente
          </ReservationPart5WeekButton>
          <ReservationPart5WeekButton onClick={() => changeWeekOffset(1)}>
            Semaine suivante{" "}
            <img
              className={reservationPart5WeekArrowRight}
              src={arrowBlack}
              width={15}
              height={15}
            />
          </ReservationPart5WeekButton>
        </div>
      </div>
      <div className={reservationPart5DatePickerContainer}>
        <p>Sélectionner une semaine spécifique</p>
        <DatePicker
          locale="fr"
          selected={datePickerDate}
          onChange={handleChange}
          dateFormat="dd/MM/yyyy"
        />
      </div>

      {loadingLock && (
        // TODO Faire un truc beau...
        <div>Chargement des créneaux en cours...</div>
      )}
      {!loadingLock && (
        <div className={reservationPart5CreneauxContainer}>
          {creneauxDisponibles &&
            Object.keys(creneauxDisponibles).map((jour, indexJour) => (
              <ReservationPart5DayColumn
                key={indexJour}
                jour={jour}
                creneauxDisponibles={creneauxDisponibles[jour]}
                changeWeekOffset={changeWeekOffset}
                changeCreneau={changeCreneau}
                creneauChoisi={creneauChoisi}
              />
            ))}
        </div>
      )}
    </ReservationSubContainer>
  )
}

ReservationPart5.propTypes = {
  creneauxDisponibles: PropTypes.object,
  changeWeekOffset: PropTypes.func,
  changeCreneau: PropTypes.func,
  creneauChoisi: PropTypes.string,
  loadingLock: PropTypes.bool,
  step: PropTypes.number,
  stepRefs: PropTypes.arrayOf(PropTypes.shape({ current: PropTypes.any })),
}
